import { render, staticRenderFns } from "./bell.vue?vue&type=template&id=73b979b3&"
import script from "./bell.vue?vue&type=script&lang=js&"
export * from "./bell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b979b3')) {
      api.createRecord('73b979b3', component.options)
    } else {
      api.reload('73b979b3', component.options)
    }
    module.hot.accept("./bell.vue?vue&type=template&id=73b979b3&", function () {
      api.rerender('73b979b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/bell.vue"
export default component.exports